import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { AUDIENCES } from "../lib/data";

export const Audiences = ({ courses, onCourse }) => (
  <section id="audiences" className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto" data-testid="audiences-section">
    <SectionHead
      overline="Who it's for"
      title={<>Four paths. <em className="text-gold-gradient not-italic">One mentor.</em></>}
      sub="Every program is taught live by Deepankshi — pick the path built for where you are, and where you want to go."
    />

    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
      {AUDIENCES.map((a, i) => (
        <Reveal key={a.id} delay={i * 0.08}>
          <motion.article
            whileHover={{ y: -6, rotate: 0.4 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="card-sheen group relative h-full rounded-2xl border border-white/10 bg-surface/70 p-8 sm:p-10 hover:border-leaf/50 transition-colors duration-500"
            data-testid={`audience-card-${a.id}`}
          >
            <span className="font-mono text-xs tracking-[0.3em] text-gold/70">{a.num}</span>
            <h3 className="mt-4 font-display text-2xl sm:text-3xl text-neutral-100">{a.title}</h3>
            <p className="mt-4 text-sm sm:text-base font-light leading-relaxed text-neutral-400">{a.focus}</p>
            <div className="mt-7 flex flex-wrap gap-2.5">
              {a.picks.map((cid) => {
                const c = courses.find((x) => x.id === cid);
                if (!c) return null;
                return (
                  <button
                    key={cid}
                    data-testid={`audience-course-${a.id}-${cid}`}
                    onClick={() => onCourse(c)}
                    className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-xs text-neutral-300 hover:border-gold/60 hover:text-champagne transition-colors duration-300"
                  >
                    {c.title.split("&")[0].split("—")[0].trim()} <ArrowUpRight size={12} className="text-gold" />
                  </button>
                );
              })}
            </div>
          </motion.article>
        </Reveal>
      ))}
    </div>
  </section>
);
